var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-setting"},[_c('p',[_vm._v("此模块只设置分类在页面中的展示位置，可拖动调整位置。")]),_c('p',[_vm._v("分类内容请返回「店铺装修」列表，点击顶部的「全局分类配置」，所有页面共用一套分类。")]),_c('p',[_vm._v("删除此展示模块不会删除分类配置，小程序分类页仍然可以使用。")])])
}]

export { render, staticRenderFns }